import { useState, useEffect } from 'react'
import { useStore } from '@nanostores/react'
import { cartData } from '@stores/cartStore.js'
import Price from '@components/Price/Price.jsx'
import { chord } from '@api/chord.js'
import va from '@vercel/analytics'

import { createCart, addToCart } from '@api/shopify.js'

const CartUpsellProduct = ({ product }) => {
    const $cartData = useStore(cartData)

    let sizeSelected = {
        variantId: '',
        size: '',
        inventoryQuantity: '',
        product_id: '',
    }
    if (product.variants.length === 1) {
        sizeSelected = {
            variantId: product.variants[0].id,
            size: 'nosize',
            inventoryQuantity: product.variants[0].inventory_quantity,
            product_id: product.id,
        }
    }

    const [selectedSize, setSelectedSize] = useState(sizeSelected)

    let isUnsized = false

    const handleSizeChange = (e) => {
        let size = e.target[e.target.selectedIndex].getAttribute('data-size')
        let variantId =
            e.target[e.target.selectedIndex].getAttribute('data-variant-id')
        let inventoryQuantity = e.target[e.target.selectedIndex].getAttribute(
            'data-inventory-quantity'
        )
        setSelectedSize({
            ...selectedSize,
            size: size,
            variantId: variantId,
            inventoryQuantity: inventoryQuantity,
        })
    }

    // console.log('product in upsellData', product)
    let productImage = product.images_info[0].src
    let productTitle = product.title.split('_')[0]
    let productColor = product.title.split('_')[1]
    let productHandle = product.handle
    let productUrl = `/products/${productHandle}`

    let productSizes

    let variants = product.variants

    if (variants) {
        productSizes = variants.map((variant) => {
            // console.log('variant', variant)
            if (variant.initial_size && variant.inventory_quantity > 0) {
                return {
                    variantId: variant.id,
                    size: variant.initial_size,
                    inventoryQuantity: variant.inventory_quantity,
                    product_id: variant.product_id,
                }
            } else if (
                variant.inventory_quantity > 0 &&
                !variant.initial_size
            ) {
                return {
                    variantId: variant.id,
                    size: 'no-size',
                    inventoryQuantity: variant.inventory_quantity,
                    product_id: variant.product_id,
                }
            } else {
                return null
            }
        })
    }

    productSizes = productSizes.filter((size) => size !== null)

    if (productSizes.length === 1 && productSizes[0].size === 'no-size') {
        isUnsized = true
    }

    // console.log('productSizes', productSizes)

    const handleAddToCart = async (e, selectedSize) => {
        console.log('selectedSize in handleAddToCart', selectedSize, product)

        e.preventDefault()

        let cartId = $cartData.cartId || ''

        let variantId = selectedSize.variantId
        var lines = {}

        if (product.tags.includes('bundle-builder-product')) {
            const metafieldForSelectedVariant = product.metafields.find(
                (m) => m.id == variantId
            )
            const originalProducts = JSON.parse(
                metafieldForSelectedVariant.value
            )
            lines = originalProducts.map((p) => {
                return {
                    quantity: 1,
                    merchandiseId: `gid://shopify/ProductVariant/${p.variant_id}`,
                    attributes: [
                        {
                            key: '_bundle_info',
                            value: JSON.stringify({
                                bundle_id: product.id,
                                bundle_name: product.title,
                                bundle_size:
                                    selectedSize.size === ''
                                        ? 'nosize'
                                        : selectedSize.size,
                                bundle_total_products: originalProducts.length,
                            }),
                        },
                        {
                            key: '_pid',
                            value: `${p.product_id}`,
                        },
                    ],
                }
            })
        } else {
            lines = {
                quantity: 1,
                merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
            }
        }

        if (!cartId || cartId === '') {
            let cartCreateData = await createCart()
            cartId = cartCreateData.data.cartId

            // console.log cartCreateData', cartCreateData)

            let cartObj = {
                ...cartData.get(),
                cartId: cartId,
                checkoutUrl: cartCreateData.data.checkoutUrl,
            }

            cartData.set(cartObj)

            addToCart(cartId, lines).then((addToCartData) => {
                // console.log addToCartData', addToCartData)
                let cartLines = addToCartData.body.cartLinesAdd.cart.lines.edges
                let cartCost = addToCartData.body.cartLinesAdd.cart.cost
                // console.log cartLines', cartLines)

                let cartObj = {
                    ...cartData.get(),
                    lines: cartLines,
                    cost: cartCost,
                }

                cartData.set(cartObj)

                const productHasSelectedVariant = !!product?.variants?.find(
                    (v) => {
                        return v?.id === variantId
                    }
                )

                const productForSelectedVariant = !!product?.variants?.find(
                    (v) => {
                        return v?.id === variantId
                    }
                )

                chord.trackProductAdded({
                    cart: $cartData,
                    product: {
                        product: product,
                        quantity: 1,
                        variantId: selectedSize?.variantId
                            ? selectedSize?.variantId
                            : variantId,
                    },
                })

                dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'add_to_cart',
                    page: 'plp',
                    type: 'cart_upsell',
                    ecommerce: {
                        currency: 'USD',
                        value: selectedSize?.price,
                        items: [
                            {
                                item_id: variantId,
                                item_name: product.title,
                                affiliation: 'Vercel',
                                item_brand: 'Monica + Andy',
                                item_category:
                                    productHasSelectedVariant.initial_color
                                        ? productHasSelectedVariant.initial_color
                                        : '',
                                item_category2: selectedSize?.size,
                                item_variant: selectedSize?.variantId,
                                price: selectedSize?.price,
                                quantity: 1,
                            },
                        ],
                    },
                })

                va.track('Cart Upsell Add To Cart', {
                    productName: product.title,
                    productSku: selectedSize?.sku,
                    productBrand: product?.vendor
                        ? product.vendor
                        : 'Monica + Andy',
                    productColor: productHasSelectedVariant.initial_color
                        ? productHasSelectedVariant.initial_color
                        : '',
                    productSize: selectedSize?.size,
                    productVariant: selectedSize?.variantId,
                    productPrice: selectedSize?.price,
                    productQuantity: 1,
                    type: 'cart_upsell',
                })

                var atcItem = {
                    name: product.title, // Replace with dynamic product name
                    price: selectedSize?.price, // Replace with dynamic product price
                    productID: selectedSize?.variantId, // Replace with dynamic product ID
                    categories: productHasSelectedVariant.initial_color
                        ? productHasSelectedVariant.initial_color
                        : '', // Replace with dynamic product categories (optional)
                    imageURL: product.images_info[0].src
                        ? product.images_info[0].src
                        : '', // Replace with dynamic product image URL
                    URL: window?.location?.href, // Replace with dynamic product page URL
                    brand: variant ? variant.vendor : '', // Replace with dynamic product brand (optional)
                }

                geq.addToCart(atcItem)
            })
        } else {
            addToCart(cartId, lines).then((addToCartData) => {
                // console.log('addToCartData', addToCartData)

                let cartLines = addToCartData.body.cartLinesAdd.cart.lines.edges
                let cartCost = addToCartData.body.cartLinesAdd.cart.cost

                let cartObj = {
                    ...cartData.get(),
                    lines: cartLines,
                    cost: cartCost,
                }

                cartData.set(cartObj)

                const productHasSelectedVariant = !!product?.variants?.find(
                    (v) => {
                        return v?.id === variantId
                    }
                )

                const productForSelectedVariant = !!product?.variants?.find(
                    (v) => {
                        return v?.id === variantId
                    }
                )

                chord.trackProductAdded({
                    cart: $cartData,
                    product: {
                        product: product,
                        quantity: 1,
                        variantId: selectedSize?.variantId
                            ? selectedSize?.variantId
                            : variantId,
                    },
                })

                dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
                dataLayer.push({
                    event: 'add_to_cart',
                    page: 'plp',
                    ecommerce: {
                        currency: 'USD',
                        value: selectedSize?.price,
                        items: [
                            {
                                item_id: selectedSize?.variantId
                                    ? selectedSize?.variantId
                                    : variantId,
                                item_name: product.title,
                                affiliation: 'Vercel',
                                item_brand: 'Monica + Andy',
                                item_category:
                                    productHasSelectedVariant.initial_color
                                        ? productHasSelectedVariant.initial_color
                                        : '',
                                item_category2: selectedSize?.size,
                                item_variant: selectedSize?.variantId,
                                price: selectedSize?.price,
                                quantity: 1,
                            },
                        ],
                    },
                })

                va.track('Cart Upsell Add To Cart', {
                    productName: product.title,
                    productSku: selectedSize?.sku,
                    productBrand: product?.vendor
                        ? product.vendor
                        : 'Monica + Andy',
                    productColor: productHasSelectedVariant.initial_color
                        ? productHasSelectedVariant.initial_color
                        : '',
                    productSize: selectedSize?.size,
                    productVariant: selectedSize?.variantId
                        ? selectedSize?.variantId
                        : variantId,
                    productPrice: selectedSize?.price,
                    productQuantity: 1,
                    type: 'cart_upsell',
                })

                var atcItem = {
                    name: product.title, // Replace with dynamic product name
                    price: selectedSize?.price, // Replace with dynamic product price
                    productID: selectedSize?.variantId, // Replace with dynamic product ID
                    categories: productHasSelectedVariant.initial_color
                        ? productHasSelectedVariant.initial_color
                        : '', // Replace with dynamic product categories (optional)
                    imageURL: product.images_info[0].src
                        ? product.images_info[0].src
                        : '', // Replace with dynamic product image URL
                    URL: window?.location?.href, // Replace with dynamic product page URL
                    brand: product?.vendor ? product.vendor : '', // Replace with dynamic product brand (optional)
                }

                geq.addToCart(atcItem)
            })
        }
    }

    // console.log('selectedSize in render', selectedSize)

    return (
        <div
            className='upsell-product mb-4 bg-white flex flex-col'
            key={product.id}
        >
            <div className='upsell-product-image aspect-square bg-[#f8f8f8]'>
                <a className='aspect-square' href={productUrl}>
                    <img
                        className='object-contain w-full h-auto aspect-square'
                        src={productImage}
                        alt={product.title}
                    />
                </a>
            </div>
            <div className='upsell-product-info p-2 bg-white flex flex-col h-full'>
                <div className='upsell-product-title text-sm h-[60px]'>
                    <a href={productUrl}>
                        {productTitle}{' '}
                        {productColor ? `- ${productColor}` : null}
                    </a>
                </div>
                {productSizes && !isUnsized && (
                    <div className='upsell-product-sizes w-full my-2'>
                        <select
                            id={`upsell-product-size-${product.id}`}
                            className='product-size-select text-xs select-css w-full border border-slate rounded-xs px-2 py-1 bg-slate'
                            value={selectedSize.size}
                            onChange={(e) => handleSizeChange(e)}
                        >
                            <option value=''>-- Please Select --</option>
                            {productSizes &&
                                productSizes.map((sizeOption, index) => {
                                    // console.log('sizeOption', sizeOption.size)
                                    return (
                                        sizeOption && (
                                            <option
                                                key={index}
                                                value={sizeOption.size}
                                                className='text-xs'
                                                data-size={sizeOption.size}
                                                data-variant-id={
                                                    sizeOption.variantId
                                                }
                                                data-inventory-quantity={
                                                    sizeOption.inventoryQuantity
                                                }
                                            >
                                                {sizeOption.size}
                                            </option>
                                        )
                                    )
                                })}
                        </select>
                    </div>
                )}

                <div className='upsell-product-price !text-xs'>
                    <Price product={product} priceType='collectionTile' />
                </div>
                <div className='upsell-product-add-to-cart pt-2 mt-auto'>
                    <button
                        className={`text-xs button-temp h-8 w-full ${
                            selectedSize.size || isUnsized
                                ? 'bg-ash text-snow hover:bg-ash/80 cursor-pointer'
                                : 'bg-slate text-snow cursor-not-allowed'
                        }`}
                        onClick={(e) => handleAddToCart(e, selectedSize)}
                    >
                        {selectedSize.size || isUnsized
                            ? 'Add To Cart'
                            : 'Please Select Size'}
                    </button>
                </div>
            </div>
        </div>
    )
}
export default CartUpsellProduct
